import { __decorate } from "tslib";
import Component from "vue-class-component";
import StringUtils from "@/utils/stringUtils";
import ReactiveComponent from "../components/ReactiveComponent";
import { Emit, Prop, PropSync } from "vue-property-decorator";
import ProgressButton from "@/components/ProgressButton.vue";
let VideoForm = class VideoForm extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.nameInvalid = false;
        this.linkInvalid = false;
    }
    created() { }
    emitSubmit() { }
    handleSubmit() {
        if (this.task.isLoading) {
            return;
        }
        this.nameInvalid = StringUtils.isBlank(this.nameValue);
        this.linkInvalid =
            StringUtils.isBlank(this.linkValue) ||
                !this.linkValue.startsWith("https://youtu.be/");
        if (this.nameInvalid || this.linkInvalid) {
            return;
        }
        this.emitSubmit();
    }
};
__decorate([
    Prop()
], VideoForm.prototype, "task", void 0);
__decorate([
    PropSync("name", { type: String, default: "" })
], VideoForm.prototype, "nameValue", void 0);
__decorate([
    PropSync("link", { type: String, default: "" })
], VideoForm.prototype, "linkValue", void 0);
__decorate([
    Emit("submit")
], VideoForm.prototype, "emitSubmit", null);
VideoForm = __decorate([
    Component({
        components: { ProgressButton }
    })
], VideoForm);
export default VideoForm;
